import { render, staticRenderFns } from "./AmountCYInputPage.vue?vue&type=template&id=b10522fc&scoped=true"
import script from "./AmountCYInputPage.vue?vue&type=script&lang=js"
export * from "./AmountCYInputPage.vue?vue&type=script&lang=js"
import style0 from "./AmountCYInputPage.vue?vue&type=style&index=0&id=b10522fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10522fc",
  null
  
)

export default component.exports